export default "__VITE_PUBLIC_ASSET__9573214f__"